// useForceUpdate.js
import { useState, useCallback } from 'react'

export default function useForceUpdate() {
  const [, setTick] = useState(0)
  return useCallback(() => setTick(t => t + 1), [])
}
